export const TimePeriods = [
  {
    value: 7,
    unit: 'days',
    title: 'Week',
    valueTitle: 1,
    saveText: '',
  },
  {
    value: 1,
    unit: 'months',
    title: 'Month',
    saveText: 'HOT DEAL',
  },
  {
    value: 3,
    unit: 'months',
    title: 'Months',
    saveText: 'POPULAR',
  },
  {
    value: 12,
    unit: 'months',
    title: 'Months',
    saveText: 'BEST VALUE',
  },
];

export const SubscriptionCategoryMap = {
  seeWhoLikedMe: 'Premium',
  supreme: 'Supreme',
};
